import { Component, OnInit } from "@angular/core";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "[avTable]",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
  standalone: false,
})
export class TableComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
